<template>
  <div class="space-y-2" v-if="location && isAtLeastOneProperty">
    <h4 class="text-base font-medium block">
      {{ $t("new.location") }}
    </h4>

    <div class="space-y-2 text-sm">
      <div
        v-if="location?.countryCode"
        class="flex flex-wrap items-center space-x-2"
      >
        <span class="font-normal">{{ $t("new.country_label") }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ getCountryLabel(location?.countryCode) }} </span>
      </div>

      <div
        v-if="location?.city?.[locale]"
        class="flex flex-wrap items-center space-x-2"
      >
        <span class="font-normal">{{ $t("new.city_label") }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ location?.city?.[locale as Locale] }} </span>
      </div>

      <div
        v-if="location?.venue.title"
        class="flex flex-wrap items-center space-x-2"
      >
        <span class="font-normal">{{ $t("artwork_details.kept") }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>{{ location?.venue?.title }} </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ArtworkLocation } from "~~/types/artwork";
import { computed } from "vue";
import { COUNTRIES } from "~/data/countries";
import { useI18n } from "vue-i18n";
import type { Locale } from "~~/types/global";

const props = defineProps<{
  location: ArtworkLocation | null | undefined;
}>();

const { locale } = useI18n();

const isAtLeastOneProperty = computed<boolean>(() => {
  if (!props.location) return false;

  return !!(
    props.location?.city?.[locale.value] ||
    props.location?.countryCode ||
    props.location?.venue?.title
  );
});

const getCountryLabel = (code: string): string => {
  const label = COUNTRIES.find((c) => c.code === code)?.label || {
    en: "",
    ru: "",
    hy: "",
  };

  return label?.[locale.value as Locale];
};
</script>
